<app-header
  text="Prüfen Sie Ihre Auswahl"
  icon="fas fa-check-circle"></app-header>
<p-divider />
<div class="grid">
  @if (bulkStore.indicators().length; as count) {
    <div class="col-6">
      <app-count-box
        [severity]="
          bulkStore.selectedEntityType() === 'Indicator' &&
          bulkStore.selectedAction() === 'remove' &&
          dataStore.indicatorsHaveData(bulkStore.indicatorIds())
            ? 'warning'
            : 'success'
        "
        icon="fas fa-ruler-vertical"
        key="indicators"
        label="Indikatoren"
        [text]="
          bulkStore.selectedEntityType() === 'Indicator' &&
          bulkStore.selectedAction() === 'remove' &&
          dataStore.indicatorsHaveData(bulkStore.indicatorIds())
            ? '<strong>Indikatoren mit Daten ausgewählt!</strong> Beim Löschen werden auch alle Daten, die mit dem Indikator verknüpft sind, <b>unwiderruflich gelöscht!</b>'
            : ''
        "
        (details)="showDetails(bulkStore.indicators(), 'indicators')"
        [count]="count"></app-count-box>
    </div>
  }

  @if (bulkStore.categories().length; as count) {
    <div class="col-6">
      <app-count-box
        [severity]="
          bulkStore.selectedEntityType() === 'Category' &&
          bulkStore.selectedAction() === 'remove' &&
          indicatorStore.categoriesHaveIndicators(bulkStore.categoryIds())
            ? 'warning'
            : 'success'
        "
        icon="fas fa-folder"
        key="categories"
        label="Indikatorenordner"
        [text]="
          bulkStore.selectedEntityType() === 'Category' &&
          bulkStore.selectedAction() === 'remove' &&
          indicatorStore.categoriesHaveIndicators(bulkStore.categoryIds())
            ? '<strong>Ordner mit Indikatoren ausgewählt!</strong> Beim Löschen werden auch alle Indikatoren und alle Daten, die in dem Indikatorenordner enthalten sind, unwiderruflich gelöscht!'
            : ''
        "
        (details)="showDetails(bulkStore.categories(), 'categories')"
        [count]="count"></app-count-box>
    </div>
  }

  @if (bulkStore.dataLayers().length; as count) {
    <div class="col-6">
      <app-count-box
        icon="fas fa-calendar-days"
        key="dataLayers"
        label="Jahre"
        (details)="showDetails(bulkStore.dataLayers(), 'dataLayers')"
        [count]="count"></app-count-box>
    </div>
  }

  @if (bulkStore.tags().length; as count) {
    <div class="col-6">
      <app-count-box
        icon="fas fa-tags"
        key="tags"
        label="Schlagworte"
        (details)="showDetails(bulkStore.tags(), 'tags')"
        [count]="count"></app-count-box>
    </div>
  }

  @if (dataStore.selection().length; as count) {
    <div class="col-6">
      <app-count-box
        icon="fas fa-database"
        key="indicatorData"
        label="Daten"
        (details)="showDetails(dataStore.selection(), 'indicatorData')"
        [count]="count"></app-count-box>
    </div>
  }
</div>
<div>
  @if (bulkStore.set(); as set) {
    <p-divider />
    <app-alert header="Indikatoren versetten" [canToggle]="false">
      Indikatoren in das Indikatorenset "{{ set.name }}" verschieben
    </app-alert>
  }

  @if (bulkStore.category(); as category) {
    <p-divider />
    <app-alert
      header="In Ordner verschieben"
      icon="fas fa-arrow-down-up-across-line"
      [canToggle]="false">
      Auswahl in den Ordner "{{ category.name }}" verschieben
    </app-alert>
  }
</div>

@if (!!itemsInOverview && itemsInOverview.length) {
  <p-sidebar
    (onHide)="closeOverview()"
    position="right"
    [modal]="false"
    styleClass="w-8"
    [visible]="!!itemsInOverview">
    <ng-template pTemplate="header">
      <app-header
        [icon]="sidebarIcon"
        [text]="sidebarHeader"
        [count]="itemsInOverview.length"></app-header
    ></ng-template>

    @if (itemType) {
      <app-bulk-overview-list
        [listType]="itemType"
        [items]="itemsInOverview"
        [labelProperty]="labelProperty"
        [icon]="sidebarIcon"></app-bulk-overview-list>
    }
  </p-sidebar>
}
<app-mask [visible]="!!itemsInOverview" (click)="closeOverview()"></app-mask>
